/*
Converts data from Backened to Highcharts compatible input
*/

function _getSeriesFromTableData(data, xDataKey, yDataKey) {
  if (data !== null) {
    return data[xDataKey].map((x, index) => [x, data[yDataKey][index]]);
  }
  return [];
}

function _generateInterpolationLineSeries(rpmData, factorParameter, powerParameter) {
  const start = Math.min(...rpmData) - 3;
  const end = Math.max(...rpmData) + 3;
  const step = 0.1;
  const series = [];
  for (let rpm = start; rpm <= end; rpm += step) {
    series.push([
      Math.round(rpm * 10) / 10,
      Math.round(factorParameter * Math.pow(rpm, powerParameter) * 100) / 100
    ]);
  }
  return series;
}

function _generateRangeLineDataSeries(rangeData, upperFactorParameter, upperPowerParameter, lowerFactorParameter, lowerPowerParameter) {
  const series = [];
  const start = rangeData.bsrUpper;
  const end = rangeData.nMcr;
  const step = 0.1;
  for (let rpm = start; rpm <= end; rpm += step) {
    series.push({
      x: Math.round(rpm * 10) / 10,
      low: lowerFactorParameter * Math.pow(rpm, lowerPowerParameter),
      high: upperFactorParameter * Math.pow(rpm, upperPowerParameter),
    });
  }
  return series;
}

function _generateSeaTrialsSeries(data, xDataKey, yDataKey) {
  if (!data) {
    return [];
  }
  return data.map((datum) => {
    return datum.measurments.map((measurment) => {
      return [measurment[xDataKey], measurment[yDataKey]];
    });
  });
}

export { _getSeriesFromTableData, _generateInterpolationLineSeries, _generateRangeLineDataSeries, _generateSeaTrialsSeries };
